<template>
    <div class="hero">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
        <!-- Hero -->
        <div id="main-hero" class="hero-body">
            <div class="container">
                <div class="columns is-vcentered pt-20 pb-50 mt-20" id="signup">
                    
                    <div class="column is-5 is-offset-1 z-index-2 welcome-signup">
                    <div class="content has-text-centered pt-20">
                        <img
                                width="225"
                                src="../assets/images/logos/logo-m.png"
                                alt="My Meatloaf Logo"
                            >
                            <div class="is-size-4">                
                                Literally, Just the Recipe
                            </div>
                            <p>
                    Skip the blog, the ads, the popups and get right to the recipe.</p>
                        </div>
                        <!-- Signup form -->
                        <div id="signup-card" class="animated preFadeInLeft fadeInLeft">
                            <div class="flex-card clean-signup-card">
                                <!--<h2 class="has-text-centered text-bold title is-3">Sign up</h2>-->
                                <b-field label="Name" label-position="inside"  v-bind:class="{ 'is-hidden': !signup}">
                                    <b-input v-model="name"                               
                                    ></b-input>
                                </b-field>
                                <b-field label="Email"
                                label-position="inside"
                                    :type="labelEmailType"
                                    :message="labelEmailMessage">
                                    <b-input type="email"
                                        v-model="email">
                                    </b-input>
                                </b-field>
                                <b-field label="Password"
                                label-position="inside"
                                    :type="labelPasswordType"
                                    :message="labelPasswordMessage">
                                    <b-input v-model="password" type="password"></b-input>
                                </b-field>
                                <b-field label="Confirm Password" v-bind:class="{ 'is-hidden': !signup}"
                                label-position="inside">
                                    <b-input v-model="checkPassword" type="password"></b-input>
                                </b-field>    
                                <div class="mt-20">
                                    <button class="button secondary-btn is-fullwidth" @click="signUp" v-if="signup">Get started now</button>
                                    <button @click="login" class="button secondary-btn is-fullwidth" v-if="!signup">Login</button>
                                    <div class="mt-20" v-if="!signup">Not a member yet? <a href="#" @click="signup = true">sign up</a>.</div>
                                    <div class="mt-20" v-if="signup">Already a member? <a href="#" @click="signup = false">login</a>.</div>
                                <p>
                                <b-button rounded @click="socialLogin" class="google-button"><img alt="Google Logo" src="../assets/google-logo.png">Sign In with Google</b-button>
                            </p>
                                </div>
                            </div>
                        </div>
                        <!-- Signup form -->
                    </div>
                    
    
                    <!-- Signup features -->
                    <div class="column is-5 is-offset-1 z-index-2">
                        <div class="is-hidden-mobile has-text-white ">
                            <h1 class="title is-1 has-text-white">Literally, Just the Recipe</h1>
                            <div class="has-text-weight-bold has-text-centered">                            
                    </div>
                            <h2 class="title is-2 has-text-centered has-text-white has-text-weight-light">
                                Sign Up and Get...
                            </h2>
                            <div class="title is-5 has-text-white has-text-weight-light">
                                <div class="">
                                    Access to hundreds of easy-to-read recipes without the annoying blog. 
                                </div>                            
                            <hr>
                                <div class="">
                                    Create and save custom meals and menus for any occassion. Our 
              meal and menu planners help you organize your ideas and create a unique pallete.
                                </div>
                            <hr>
                                <div class="">
                                    Upload your recipes to your online kitchen and share with friends. Your kitchen is more than just a collection of recipes; 
                                    its an onramp for new followers to discover your brand.
                                </div>
                                <div class="has-text-weight-bold has-text-centered mt-20">     
                                    <a href="#" @click="$emit('update:open', false);">Continue Browsing</a>                  
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';
export default {
    name: 'signUp',
    data() {
        return {
            email: '',
            name: '',
            password: '',
            checkPassword:'',
            labelEmailType: '',
            labelPasswordType: '',
            labelEmailMessage: '',
            labelPasswordMessage: [],
            PasswordRules: [
				{ message:'One lowercase letter required.', regex:/[a-z]+/ },
				{ message:"One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message:"8 characters minimum.", regex:/.{8,}/ },
				{ message:"One number required.", regex:/[0-9]+/ }
			],
            isValid: false,
            isLoading: false,
            isFullPage: true,
            signup: true
        }
    },
    props: {
         open: Boolean
      },
    mounted() {
        let user = firebase.auth().currentUser;
        if (user) {
            this.$router.replace('/');
        }
    },
    methods: {
        signUp: function() {            
            this.validate().then((isValid) => {
                console.log(isValid)
                if(!isValid) {
                    this.isLoading = false;
                    if (!this.name) {
                        this.danger('Name cannot be empty');
                    }
                }
                else {
                    this.isLoading = true;
                    firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
                    (user) => {
                        db.collection("users").doc(user.user.uid).set({
                                    id: user.user.uid,
                                    name: this.name,
                                    kitchen_name: this.name,
                                    image: null,
                                    created_at: new Date(),
                        });
                        user.user.sendEmailVerification().then(this.$router.replace('/account'));
                    }).catch((err) => {
                if(err.code == "auth/email-already-in-use") {
                    this.danger('Email already in use');
                    this.isLoading = false;
                }
                else {
                    this.danger('Something went wrong. Try again.');
                    this.isLoading = false;
                }
            });
                }
            })
            
        },
        login() {
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {

                this.$router.replace('/');
            }).catch((err) => {
                alert('Oops. ' + err.message)
            });
        },
        socialLogin() {
            const vm = this;
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then((user) => {
                
                var docRef = db.collection("users").doc(user.user.uid);
                docRef.get().then(function(doc) {
                    if (doc.exists) {
                        vm.$router.replace('/account');
                    } else {
                         db.collection("users").doc(user.user.uid).set({
                                    id: user.user.uid,
                                    name: user.user.displayName,
                                    kitchen_name: user.user.displayName,
                                    image: null,
                                    created_at: new Date(),
                        }).then(()=>{
                            window.location='/account'
                        });
                        
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            }).catch((err) => {
                alert('Oops. ' + err.message)
            });
        },
        async validate() {
            if(this.signup) {            
            this.labelPasswordMessage=[];
            this.labelPasswordType='';
            this.labelEmailType = '';
            this.labelEmailMessage = '';
            this.isValid = true;
                if(!this.name) {
                    this.isValid = false;
                }
                if(!this.validEmail(this.email)) {
                    this.labelEmailType = 'is-danger';
                    this.labelEmailMessage = 'Valid email required';
                    this.isValid = false;
                }
                for (let condition of this.PasswordRules) {
                    if (!condition.regex.test(this.password)) {
                        this.labelPasswordMessage.push(condition.message)
                        this.labelPasswordType = "is-danger";
                        this.isValid = false;
                    }
                }
                if(this.password !== this.checkPassword) {
                    this.labelPasswordMessage.push('Passwords do not match')
                    this.isValid = false;
                }
                return this.isValid;
                }
        },
        validEmail:function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        danger(error) {
            this.$buefy.toast.open({
                duration: 5000,
                message: error,
                position: 'is-top',
                type: 'is-danger'
            })
        }
    }
}
</script>

<style scoped>
.sign-up {
    margin-top: 40px;
}

input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
}

span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
}
</style>